module.exports = __webpack_public_path__ + "static/media/cert_100.8a7fdc35.jpg";